import { FlowEvent, StepIndex } from './common';

export type PaymentFlowName =
  | 'login_trial_expired_paywall'
  | 'login_subscription_expired_paywall'
  | 'pricing_buy_now'
  | 'public_library_theme_private_content'
  | 'library_theme_private_content'
  | 'teacher_pro_upsell_teacher_pro_menu';

export enum PaymentFlowEventName {
  stepViewed = 'payment_flow_step_viewed',
  optionSelected = 'payment_flow_option_selected',
  stepContinue = 'payment_flow_step_continue',
  failed = 'payment_flow_failed',
}

export enum PaymentSection {
  auth = 'auth',
  eligibility = 'eligibility',
  paywall = 'paywall',
  checkout = 'checkout',
  pricing = 'pricing',
  upsell = 'upsell',
}

export enum PaymentFlowStep {
  subscriptionOnlyContentViewed = 'subscription_only_content_viewed',
  loginCompleted = 'login_completed',
  subscriptionExpiredDetected = 'subscription_expired_detected',
  paymentModalViewed = 'payment_modal_viewed',
  payClicked = 'pay_clicked',
  recurrenceModal = 'recurrence_modal',
  recurrenceSelected = 'recurrence_selected',
  checkoutViewed = 'checkout_viewed',
  paymentSubmitted = 'payment_submitted',
  paymentFailed = 'payment_failed',
  paymentSuccess = 'payment_success',
}

export type PaymentFlowEvent<
  FlowSection extends string = string,
  EventName extends string = string,
  StepName extends string = string,
  Index extends StepIndex = StepIndex,
> = FlowEvent<PaymentFlowName, FlowSection, EventName, StepName, Index>;

export type PaymentFlowEventData = {
  calculationData?: Record<string, unknown>;
  option?: string;
};
